import * as React from "react";
const SvgWomanEmptyBox = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 500 500", ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 60.23, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-2--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 130.98, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-3--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 65.58, y: 218.93, width: 105.96, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-4--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 136.33, y: 218.93, width: 35.21, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-5--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-6--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-7--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 218.7, width: 105.96, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-8--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 218.7, width: 35.21, height: 89.01, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-9--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 350.32, y: 145, width: 87.65, height: 73.63, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-10--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 408.85, y: 145, width: 29.12, height: 73.63, style: {
  fill: "#4166FB",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-11--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 251.03, y: 367.65, width: 151.73, height: 17.66, style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-12--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 271.17, y: 189.13, width: 84.21, height: 69.1, style: {
  fill: "#4166FB",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("clipPath", { id: "freepik--clip-path-13--inject-33" }, /* @__PURE__ */ React.createElement("path", { d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z", style: {
  fill: "#4166FB",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }))), /* @__PURE__ */ React.createElement("g", { id: "freepik--background-simple--inject-33" }, /* @__PURE__ */ React.createElement("path", { d: "M101.17,344.29s40.41,51.17,109.47,53.25,130.82-41,181.77-74.52,67.67-89.68,42.23-136-71.6-30.45-127-63S242.31,74.4,178,77.32,60.54,148.92,62.88,225.86,101.17,344.29,101.17,344.29Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("path", { d: "M101.17,344.29s40.41,51.17,109.47,53.25,130.82-41,181.77-74.52,67.67-89.68,42.23-136-71.6-30.45-127-63S242.31,74.4,178,77.32,60.54,148.92,62.88,225.86,101.17,344.29,101.17,344.29Z", style: {
  fill: "#fff",
  opacity: 0.7000000000000001
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--Plants--inject-33" }, /* @__PURE__ */ React.createElement("path", { d: "M113.73,91.08c-.06,0,.7-3.73.77-4,.86-2.67,4.1-7.31,7.23-7.3A3.71,3.71,0,0,1,125.3,84c-.23,2.2-2.21,4.08-4,5.16C119.2,90.47,113.73,91.08,113.73,91.08Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("path", { d: "M107.66,66c3,1.06,4.42,6.52,4.32,9.32,0,.24-.56,4-.61,4l-.06,0c.23.86.48,1.79.73,2.81.44,1.88.92,4,1.29,6.36a65.63,65.63,0,0,1,.84,7.64,48.28,48.28,0,0,1-.29,8.6.36.36,0,0,0,0,.1c.39-.83,1.55-3.13,1.65-3.29,1.54-2.34,5.88-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92-2.27.65-7.33-.11-7.73-.18a65.43,65.43,0,0,1-1.86,8.57q-.7,2.46-1.52,4.91c.35-.71.68-1.34.73-1.42,1.54-2.35,5.89-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92s-6.37,0-7.51-.15l-.63,1.88c-1,3-2.09,6-3,8.94-.33,1-.62,2.08-.91,3.12.32-.63.59-1.16.64-1.24,1.53-2.34,5.88-6,8.9-5.13a3.72,3.72,0,0,1,2.33,5c-.8,2.07-3.21,3.35-5.22,3.93s-5.94.07-7.3-.12c-.27,1.07-.53,2.14-.74,3.19-.13.73-.3,1.41-.39,2.14l-.3,2.15c-.14,1.37-.3,2.78-.4,4.12-.08.93-.14,1.82-.2,2.72.32-1,1-3.07,1-3.23a14.42,14.42,0,0,1,4.8-5.46,3.63,3.63,0,0,1,.41-.72,3.7,3.7,0,0,1,5.45-.85c2.38,2.05,1.78,7.67.69,10.25-.06.15-.95,1.72-1.52,2.71.43-.53.83-1.05,1.28-1.58.87-1.07,1.77-2.11,2.73-3.23l1.47-1.59c.48-.54,1.06-1,1.59-1.59,1.25-1.21,2.58-2.38,3.95-3.53-.93-.76-4.21-3.52-5.15-5.4s-1.61-4.51-.63-6.5a3.72,3.72,0,0,1,5.27-1.67c2.65,1.67,2.92,7.32,2.23,10,0,.17-.76,2.06-1.17,3.09.83-.68,1.65-1.36,2.51-2,2.48-1.91,5.05-3.78,7.6-5.65l2.33-1.72c-.33-.27-4.29-3.47-5.35-5.58-.93-1.87-1.61-4.51-.63-6.49a3.71,3.71,0,0,1,5.27-1.67c2.66,1.66,2.92,7.31,2.23,10-.05.2-1.08,2.92-1.37,3.6,1.7-1.27,3.39-2.55,5-3.89a64.65,64.65,0,0,0,6.2-5.77c-.15-.13-4.3-3.45-5.38-5.6-.94-1.87-1.61-4.52-.63-6.5a3.71,3.71,0,0,1,5.26-1.67c2.66,1.67,2.93,7.32,2.24,10,0,.18-.83,2.25-1.22,3.23l.15.1a48.44,48.44,0,0,0,5.09-6.84c.84-1.33,1.56-2.64,2.24-3.93-.84-.54-4.63-3.05-5.82-4.88s-2.09-4.31-1.34-6.39a3.71,3.71,0,0,1,5.05-2.24c2.83,1.37,3.71,7,3.32,9.73,0,.15-.4,1.66-.69,2.75.29-.59.61-1.19.88-1.76,1-2.13,1.85-4.15,2.55-6,.4-1,.73-1.95,1-2.83-.55-1-2.69-4.84-2.9-7s.13-4.78,1.76-6.28a3.71,3.71,0,0,1,5.51.34c1.88,2.51.09,7.88-1.53,10.16-.14.2-2.69,3-2.72,3l0-.06c-.28.85-.58,1.76-.94,2.74-.66,1.82-1.43,3.86-2.42,6a67.81,67.81,0,0,1-3.53,6.83,48.53,48.53,0,0,1-5,7l-.07.08c.78-.48,3-1.76,3.19-1.84,2.58-1.1,8.2-1.72,10.26.64a3.71,3.71,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.52.4-2.25-.72-6-4.14-6.34-4.42a65,65,0,0,1-6.28,6.12c-1.29,1.11-2.63,2.19-4,3.26.69-.4,1.31-.75,1.4-.79,2.57-1.1,8.19-1.72,10.25.64a3.7,3.7,0,0,1-.82,5.46c-1.8,1.28-4.52,1-6.51.4s-5.32-3.5-6.18-4.27c-.53.4-1,.81-1.57,1.22-2.51,1.92-5,3.83-7.45,5.79-.85.68-1.66,1.39-2.48,2.1l1.22-.68c2.57-1.1,8.19-1.73,10.25.63a3.72,3.72,0,0,1-.82,5.47c-1.8,1.28-4.52,1-6.51.39s-5-3.22-6-4.13c-.81.75-1.63,1.5-2.38,2.26-.51.53-1,1-1.5,1.57l-1.44,1.62c-.87,1.07-1.78,2.16-2.61,3.22-.58.73-1.12,1.44-1.66,2.16.83-.7,2.51-2,2.66-2.12,2.37-1.48,7.84-3,10.23-.92a3.71,3.71,0,0,1,0,5.52c-1.6,1.54-4.32,1.7-6.38,1.38-2.28-.36-6.4-3-6.91-3.38-.9,1.19-1.76,2.34-2.56,3.45-2.77,3.83-4.93,7.13-6.41,9.45l-.15.24-1.92-.93.3-.46c1.55-2.32,3.81-5.6,6.69-9.4.91-1.21,1.9-2.48,2.93-3.77a40.65,40.65,0,0,1-3-3.69c-2.21.87-6.79.9-7.39.9-.09,1.48-.17,2.93-.23,4.29-.2,4.72-.18,8.66-.13,11.42v.32l-2.11-1c0-2.74.11-6.44.39-10.82.09-1.5.22-3.11.37-4.76-.59-.15-5.36-1.37-7.16-2.81-1.63-1.31-3.35-3.42-3.29-5.64a3.71,3.71,0,0,1,4.08-3.72c3.11.4,5.72,5.42,6.23,8.17,0,.17.16,2,.22,3.1.07-.67.12-1.33.2-2,.13-1.37.31-2.73.5-4.2.11-.71.23-1.42.34-2.14s.3-1.46.45-2.2c.38-1.7.84-3.41,1.35-5.12-1.2-.12-5.45-.62-7.27-1.67s-3.84-2.87-4.11-5.07a3.71,3.71,0,0,1,3.47-4.3c3.13-.07,6.47,4.49,7.39,7.14.06.16.51,2.13.74,3.22.31-1,.61-2.05,1-3.08,1-3,2.13-5.93,3.23-8.9.34-.91.66-1.82,1-2.73-.43,0-5.5-.53-7.54-1.7-1.81-1-3.83-2.87-4.11-5.07a3.72,3.72,0,0,1,3.47-4.3c3.14-.07,6.48,4.49,7.4,7.14.07.2.71,3,.84,3.76.72-2,1.43-4,2-6a64.85,64.85,0,0,0,2-8.24c-.2,0-5.49-.5-7.58-1.7-1.82-1-3.84-2.87-4.11-5.07a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.48,7.39,7.13.06.17.56,2.33.77,3.37h.17a47.81,47.81,0,0,0,.48-8.51c0-1.57-.15-3.06-.3-4.51-1,0-5.54,0-7.54-.87s-4.13-2.43-4.65-4.58a3.71,3.71,0,0,1,3-4.65c3.11-.43,6.93,3.75,8.14,6.27.06.14.58,1.61.93,2.69-.07-.66-.14-1.34-.23-2-.31-2.35-.75-4.48-1.15-6.37-.24-1.07-.47-2-.7-2.93-1-.5-4.92-2.56-6.26-4.22s-2.54-4.07-2-6.21A3.71,3.71,0,0,1,107.66,66Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("path", { d: "M164.34,114.29c-2.45-.1-7.35-2.61-7.35-2.61s2.63-2.73,2.82-2.88c2.19-1.74,7.45-3.83,10.06-2.09a3.7,3.7,0,0,1,.65,5.48C169.12,113.9,166.43,114.38,164.34,114.29Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  opacity: 0.5
} }, /* @__PURE__ */ React.createElement("path", { d: "M113.73,91.08c-.06,0,.7-3.73.77-4,.86-2.67,4.1-7.31,7.23-7.3A3.71,3.71,0,0,1,125.3,84c-.23,2.2-2.21,4.08-4,5.16C119.2,90.47,113.73,91.08,113.73,91.08Z", style: {
  fill: "#fff"
} }), /* @__PURE__ */ React.createElement("path", { d: "M107.66,66c3,1.06,4.42,6.52,4.32,9.32,0,.24-.56,4-.61,4l-.06,0c.23.86.48,1.79.73,2.81.44,1.88.92,4,1.29,6.36a65.63,65.63,0,0,1,.84,7.64,48.28,48.28,0,0,1-.29,8.6.36.36,0,0,0,0,.1c.39-.83,1.55-3.13,1.65-3.29,1.54-2.34,5.88-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92-2.27.65-7.33-.11-7.73-.18a65.43,65.43,0,0,1-1.86,8.57q-.7,2.46-1.52,4.91c.35-.71.68-1.34.73-1.42,1.54-2.35,5.89-6,8.91-5.13a3.7,3.7,0,0,1,2.32,5c-.8,2.06-3.2,3.35-5.21,3.92s-6.37,0-7.51-.15l-.63,1.88c-1,3-2.09,6-3,8.94-.33,1-.62,2.08-.91,3.12.32-.63.59-1.16.64-1.24,1.53-2.34,5.88-6,8.9-5.13a3.72,3.72,0,0,1,2.33,5c-.8,2.07-3.21,3.35-5.22,3.93s-5.94.07-7.3-.12c-.27,1.07-.53,2.14-.74,3.19-.13.73-.3,1.41-.39,2.14l-.3,2.15c-.14,1.37-.3,2.78-.4,4.12-.08.93-.14,1.82-.2,2.72.32-1,1-3.07,1-3.23a14.42,14.42,0,0,1,4.8-5.46,3.63,3.63,0,0,1,.41-.72,3.7,3.7,0,0,1,5.45-.85c2.38,2.05,1.78,7.67.69,10.25-.06.15-.95,1.72-1.52,2.71.43-.53.83-1.05,1.28-1.58.87-1.07,1.77-2.11,2.73-3.23l1.47-1.59c.48-.54,1.06-1,1.59-1.59,1.25-1.21,2.58-2.38,3.95-3.53-.93-.76-4.21-3.52-5.15-5.4s-1.61-4.51-.63-6.5a3.72,3.72,0,0,1,5.27-1.67c2.65,1.67,2.92,7.32,2.23,10,0,.17-.76,2.06-1.17,3.09.83-.68,1.65-1.36,2.51-2,2.48-1.91,5.05-3.78,7.6-5.65l2.33-1.72c-.33-.27-4.29-3.47-5.35-5.58-.93-1.87-1.61-4.51-.63-6.49a3.71,3.71,0,0,1,5.27-1.67c2.66,1.66,2.92,7.31,2.23,10-.05.2-1.08,2.92-1.37,3.6,1.7-1.27,3.39-2.55,5-3.89a64.65,64.65,0,0,0,6.2-5.77c-.15-.13-4.3-3.45-5.38-5.6-.94-1.87-1.61-4.52-.63-6.5a3.71,3.71,0,0,1,5.26-1.67c2.66,1.67,2.93,7.32,2.24,10,0,.18-.83,2.25-1.22,3.23l.15.1a48.44,48.44,0,0,0,5.09-6.84c.84-1.33,1.56-2.64,2.24-3.93-.84-.54-4.63-3.05-5.82-4.88s-2.09-4.31-1.34-6.39a3.71,3.71,0,0,1,5.05-2.24c2.83,1.37,3.71,7,3.32,9.73,0,.15-.4,1.66-.69,2.75.29-.59.61-1.19.88-1.76,1-2.13,1.85-4.15,2.55-6,.4-1,.73-1.95,1-2.83-.55-1-2.69-4.84-2.9-7s.13-4.78,1.76-6.28a3.71,3.71,0,0,1,5.51.34c1.88,2.51.09,7.88-1.53,10.16-.14.2-2.69,3-2.72,3l0-.06c-.28.85-.58,1.76-.94,2.74-.66,1.82-1.43,3.86-2.42,6a67.81,67.81,0,0,1-3.53,6.83,48.53,48.53,0,0,1-5,7l-.07.08c.78-.48,3-1.76,3.19-1.84,2.58-1.1,8.2-1.72,10.26.64a3.71,3.71,0,0,1-.82,5.46c-1.81,1.28-4.52,1-6.52.4-2.25-.72-6-4.14-6.34-4.42a65,65,0,0,1-6.28,6.12c-1.29,1.11-2.63,2.19-4,3.26.69-.4,1.31-.75,1.4-.79,2.57-1.1,8.19-1.72,10.25.64a3.7,3.7,0,0,1-.82,5.46c-1.8,1.28-4.52,1-6.51.4s-5.32-3.5-6.18-4.27c-.53.4-1,.81-1.57,1.22-2.51,1.92-5,3.83-7.45,5.79-.85.68-1.66,1.39-2.48,2.1l1.22-.68c2.57-1.1,8.19-1.73,10.25.63a3.72,3.72,0,0,1-.82,5.47c-1.8,1.28-4.52,1-6.51.39s-5-3.22-6-4.13c-.81.75-1.63,1.5-2.38,2.26-.51.53-1,1-1.5,1.57l-1.44,1.62c-.87,1.07-1.78,2.16-2.61,3.22-.58.73-1.12,1.44-1.66,2.16.83-.7,2.51-2,2.66-2.12,2.37-1.48,7.84-3,10.23-.92a3.71,3.71,0,0,1,0,5.52c-1.6,1.54-4.32,1.7-6.38,1.38-2.28-.36-6.4-3-6.91-3.38-.9,1.19-1.76,2.34-2.56,3.45-2.77,3.83-4.93,7.13-6.41,9.45l-.15.24-1.92-.93.3-.46c1.55-2.32,3.81-5.6,6.69-9.4.91-1.21,1.9-2.48,2.93-3.77a40.65,40.65,0,0,1-3-3.69c-2.21.87-6.79.9-7.39.9-.09,1.48-.17,2.93-.23,4.29-.2,4.72-.18,8.66-.13,11.42v.32l-2.11-1c0-2.74.11-6.44.39-10.82.09-1.5.22-3.11.37-4.76-.59-.15-5.36-1.37-7.16-2.81-1.63-1.31-3.35-3.42-3.29-5.64a3.71,3.71,0,0,1,4.08-3.72c3.11.4,5.72,5.42,6.23,8.17,0,.17.16,2,.22,3.1.07-.67.12-1.33.2-2,.13-1.37.31-2.73.5-4.2.11-.71.23-1.42.34-2.14s.3-1.46.45-2.2c.38-1.7.84-3.41,1.35-5.12-1.2-.12-5.45-.62-7.27-1.67s-3.84-2.87-4.11-5.07a3.71,3.71,0,0,1,3.47-4.3c3.13-.07,6.47,4.49,7.39,7.14.06.16.51,2.13.74,3.22.31-1,.61-2.05,1-3.08,1-3,2.13-5.93,3.23-8.9.34-.91.66-1.82,1-2.73-.43,0-5.5-.53-7.54-1.7-1.81-1-3.83-2.87-4.11-5.07a3.72,3.72,0,0,1,3.47-4.3c3.14-.07,6.48,4.49,7.4,7.14.07.2.71,3,.84,3.76.72-2,1.43-4,2-6a64.85,64.85,0,0,0,2-8.24c-.2,0-5.49-.5-7.58-1.7-1.82-1-3.84-2.87-4.11-5.07a3.7,3.7,0,0,1,3.47-4.29c3.13-.08,6.47,4.48,7.39,7.13.06.17.56,2.33.77,3.37h.17a47.81,47.81,0,0,0,.48-8.51c0-1.57-.15-3.06-.3-4.51-1,0-5.54,0-7.54-.87s-4.13-2.43-4.65-4.58a3.71,3.71,0,0,1,3-4.65c3.11-.43,6.93,3.75,8.14,6.27.06.14.58,1.61.93,2.69-.07-.66-.14-1.34-.23-2-.31-2.35-.75-4.48-1.15-6.37-.24-1.07-.47-2-.7-2.93-1-.5-4.92-2.56-6.26-4.22s-2.54-4.07-2-6.21A3.71,3.71,0,0,1,107.66,66Z", style: {
  fill: "#fff"
} }), /* @__PURE__ */ React.createElement("path", { d: "M164.34,114.29c-2.45-.1-7.35-2.61-7.35-2.61s2.63-2.73,2.82-2.88c2.19-1.74,7.45-3.83,10.06-2.09a3.7,3.7,0,0,1,.65,5.48C169.12,113.9,166.43,114.38,164.34,114.29Z", style: {
  fill: "#fff"
} })), /* @__PURE__ */ React.createElement("path", { d: "M135.73,175.65s-14.87-35.84-23.19-34.28,14.27,57.14,14.27,57.14-26.16-49.35-44-49.35S89.35,203.7,112,221.88c0,0-35.68-38.44-56.49-30.13S97.08,239,97.08,239,60.81,227.59,65,236.43s15.46,10.38,15.46,10.38L90,248.89h52l8-3.11s33.3-16.63,24.38-23.38-28.54,7.79-28.54,7.79,33.89-37.4,27.35-51.42-35.68,25.45-35.68,25.45,23.79-50.39,19-59.22S135.73,175.65,135.73,175.65Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("path", { d: "M135.73,175.65s-14.87-35.84-23.19-34.28,14.27,57.14,14.27,57.14-26.16-49.35-44-49.35S89.35,203.7,112,221.88c0,0-35.68-38.44-56.49-30.13S97.08,239,97.08,239,60.81,227.59,65,236.43s15.46,10.38,15.46,10.38L96,248.89h42l12-3.11s33.3-16.63,24.38-23.38-28.54,7.79-28.54,7.79,33.89-37.4,27.35-51.42-35.68,25.45-35.68,25.45,23.79-50.39,19-59.22S135.73,175.65,135.73,175.65Z", style: {
  fill: "#fff",
  opacity: 0.4
} }), /* @__PURE__ */ React.createElement("path", { d: "M140.49,177.54c-13.08,38.65-13.08,66-13.08,66s15.46.6,31.51-11.3", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M134,198.35a232.21,232.21,0,0,0-10.71-33.89", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M95.3,175.75l33.29,49.36s22.6-19,30.33-29.73", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M128,237s-35.08-16.65-49.35-26.16", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--Shelf--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 226.38, y: 95.63, width: 7.23, height: 301.29, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 96.32, y: 95.63, width: 7.23, height: 301.29, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 161.35, y: 95.63, width: 7.23, height: 301.29, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 291.4, y: 95.63, width: 7.23, height: 301.29, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 93.99, y: 105.02, width: 202.47, height: 13.73, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 166.16, y: 105.02, width: 130.3, height: 13.73, style: {
  fill: "#a6a6a6",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 93.99, y: 243.27, width: 202.47, height: 13.73, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 166.16, y: 243.27, width: 130.3, height: 13.73, style: {
  fill: "#a6a6a6",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 93.99, y: 381.51, width: 202.47, height: 13.73, style: {
  fill: "#c2c2c2",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 166.16, y: 381.51, width: 130.3, height: 13.73, style: {
  fill: "#a6a6a6",
  stroke: "#ababab",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--Boxes--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 60.23, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 60.23, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#fff",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.6000000000000001
} })), /* @__PURE__ */ React.createElement("rect", { x: 60.23, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 130.98, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-2--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 130.98, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#fff",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.39
} })), /* @__PURE__ */ React.createElement("rect", { x: 130.98, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 148.95, y1: 308.04, x2: 148.95, y2: 396.92, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 65.58, y: 218.93, width: 105.96, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-3--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 65.58, y: 218.93, width: 105.96, height: 89.01, style: {
  fill: "#fff",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.6000000000000001
} })), /* @__PURE__ */ React.createElement("rect", { x: 65.58, y: 218.93, width: 105.96, height: 89.01, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 136.33, y: 218.93, width: 35.21, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-4--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 136.33, y: 218.93, width: 35.21, height: 89.01, style: {
  fill: "#fff",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.39
} })), /* @__PURE__ */ React.createElement("rect", { x: 136.33, y: 218.93, width: 35.21, height: 89.01, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 154.3, y1: 219.17, x2: 154.3, y2: 308.05, style: {
  fill: "none",
  stroke: "#696969",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-5--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.6000000000000001
} })), /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 307.8, width: 105.96, height: 89.01, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-6--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.39
} })), /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 307.8, width: 35.21, height: 89.01, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 430.04, y1: 308.04, x2: 430.04, y2: 396.92, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 218.7, width: 105.96, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-7--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 218.7, width: 105.96, height: 89.01, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.6000000000000001
} })), /* @__PURE__ */ React.createElement("rect", { x: 341.32, y: 218.7, width: 105.96, height: 89.01, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 218.7, width: 35.21, height: 89.01, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-8--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 218.7, width: 35.21, height: 89.01, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.39
} })), /* @__PURE__ */ React.createElement("rect", { x: 412.07, y: 218.7, width: 35.21, height: 89.01, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 430.04, y1: 218.94, x2: 430.04, y2: 307.82, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 350.32, y: 145, width: 87.65, height: 73.63, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-9--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 350.32, y: 145, width: 87.65, height: 73.63, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.6000000000000001
} })), /* @__PURE__ */ React.createElement("rect", { x: 350.32, y: 145, width: 87.65, height: 73.63, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 408.85, y: 145, width: 29.12, height: 73.63, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-10--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 408.85, y: 145, width: 29.12, height: 73.63, style: {
  fill: "#fff",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.39
} })), /* @__PURE__ */ React.createElement("rect", { x: 408.85, y: 145, width: 29.12, height: 73.63, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 423.71, y1: 145.2, x2: 423.71, y2: 218.72, style: {
  fill: "none",
  stroke: "#919191",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--hand-truck--inject-33" }, /* @__PURE__ */ React.createElement("rect", { x: 413.03, y: 363.35, width: 13.73, height: 8.59, style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("circle", { cx: 297.56, cy: 388.62, r: 8.3, style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 429.24, y: 251.24, width: 4.9, height: 137.57, style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M431.53,299.36l-11.59-9.22a32.91,32.91,0,0,1-11.43-33.67,8.28,8.28,0,0,1,8-6.27h30a8.26,8.26,0,0,1,8,6.27h0a32.9,32.9,0,0,1-11.42,33.67Zm-15-44.47a3.57,3.57,0,0,0-3.48,2.72,28.18,28.18,0,0,0,9.79,28.86l8.67,6.9,8.68-6.9A28.2,28.2,0,0,0,450,257.61h0a3.58,3.58,0,0,0-3.48-2.72Z", style: {
  fill: "#263238"
} }), /* @__PURE__ */ React.createElement("rect", { x: 251.03, y: 367.65, width: 151.73, height: 17.66, style: {
  fill: "#fff"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-11--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 251.03, y: 367.65, width: 151.73, height: 17.66, style: {
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.28
} })), /* @__PURE__ */ React.createElement("rect", { x: 251.03, y: 367.65, width: 151.73, height: 17.66, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 251.03, y: 367.65, width: 17, height: 17.66, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 385.75, y: 367.65, width: 17, height: 17.66, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 318.39, y: 367.65, width: 17, height: 17.66, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "402.76 385.31 413.22 385.31 426.3 335.6 415.84 335.6 402.76 385.31", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 424.83, y: 356.53, width: 13.73, height: 22.24, style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M428.33,396.92h0a3,3,0,0,1-2.95-2.95V382.9a3,3,0,0,1,2.95-2.95h0a3,3,0,0,1,2.95,2.95V394A3,3,0,0,1,428.33,396.92Z", style: {
  fill: "#263238"
} }), /* @__PURE__ */ React.createElement("path", { d: "M435.34,396.92h0a3,3,0,0,1-2.95-2.95V382.9a3,3,0,0,1,2.95-2.95h0a3,3,0,0,1,3,2.95V394A3,3,0,0,1,435.34,396.92Z", style: {
  fill: "#263238"
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--Floor--inject-33" }, /* @__PURE__ */ React.createElement("line", { x1: 46.82, y1: 396.92, x2: 460.63, y2: 396.92, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })), /* @__PURE__ */ React.createElement("g", { id: "freepik--Character--inject-33" }, /* @__PURE__ */ React.createElement("ellipse", { cx: 189.59, cy: 417.03, rx: 72.24, ry: 8.78, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("ellipse", { cx: 189.59, cy: 417.03, rx: 72.24, ry: 8.78, style: {
  fill: "#fff",
  opacity: 0.5
} }), /* @__PURE__ */ React.createElement("path", { d: "M339.08,417c0,2.42-16.13,4.38-36,4.38s-36-2-36-4.38,16.12-4.37,36-4.37S339.08,414.62,339.08,417Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("path", { d: "M339.08,417c0,2.42-16.13,4.38-36,4.38s-36-2-36-4.38,16.12-4.37,36-4.37S339.08,414.62,339.08,417Z", style: {
  fill: "#fff",
  opacity: 0.5
} }), /* @__PURE__ */ React.createElement("path", { d: "M204,127.79s-5.59-4.39-12-2.2-11.27,12.87-13,21.55-8.38,15.26-6.78,25.44,13.17,11.77,27.14,13.27,21.55-.2,28.13-9.38,3.79-20.35-.1-30.23-10.37-19.05-15.76-20.75S204,127.79,204,127.79Z", style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M180.9,180a16.55,16.55,0,0,0,2.93,1", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M202.6,134.9A68.93,68.93,0,0,1,194,149.18c-5.72,7.35-18.37,14.29-19.18,22a7.35,7.35,0,0,0,1.77,5.77", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M225.81,171.77a12.86,12.86,0,0,1-1.58,2.72", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M221,152.45s6.43,7.42,5.81,15.34", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M201.38,130.81a15.77,15.77,0,0,0-13.47,5.31c-.23.26-.44.52-.64.78", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M164.49,319.3l-1.25,19.24s-5.32,25.81-7,36.45-4.76,26.82-5.32,26.82-9.74,5.55-12.68,10.08.79,6.45,4.87,5,9.62-5.55,11.43-10.42,2.71-6.68,2.83-7.47,19.47-52.74,21.39-58.29,6-21.85,6-21.85l9.51-32.26s10.18,33.17,10.3,34.64,10.52,86.25,11,89.42.34,5.43,2.26,6.11,6.45.68,8.83.68,10.64,1.25,14.71.23,4.53-1.7,1.7-3.74-18.55-3.34-20-9.28c-.12-.45-.23-87.72-.23-87.72s-1.36-28.86-3.62-37h-52.3Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M143.1,416.87c4.07-1.48,9.62-5.55,11.43-10.42l.38-1c-2.31,2.46-6,5.88-6,5.88a7.3,7.3,0,0,0-1.47-3.17,2.65,2.65,0,0,0-2.61-.79l4-4.4c-3,1.86-8.4,5.66-10.52,8.93C135.28,416.41,139,418.34,143.1,416.87Z", style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M243,413.92c-1.94-1.39-9.91-2.44-15.23-4.87a1.8,1.8,0,0,0-.5.69,20,20,0,0,0-.79,2.94l-11-2.35,0,.31c.45,3.17.34,5.43,2.26,6.11s6.45.68,8.83.68,10.64,1.25,14.71.23S245.87,416,243,413.92Z", style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M179.73,233s-5.19,2.39-11.47,13.67c-6.87,12.31-5.69,19.15-5.79,34s-.4,39.5-.4,39.5,19,5.09,32.63,4.29,30.92-3.89,30.92-3.89-3.69-50.28-7.18-64.74-5.59-21-5.59-21a82.83,82.83,0,0,1-20.35.3C180.93,234,179.73,233,179.73,233Z", style: {
  fill: "#263238",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M201.59,277.47c.52,1.71,1,3.44,1.42,5.17", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M189.54,249.17a166.59,166.59,0,0,1,10.34,23.12", style: {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M307.12,223.44c-.6-.4-10.43-1.94-10.43-1.94l-1.92-.79s11.9.95,12,.45.5-1.1-.3-1.2-16.11-3.21-16.11-3.21,3.89-3.68,4.39-4.48,1.19-2.4.39-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.78,3.59-4.78,3.59l-41.58-5.72s-14.6-18-17.77-21.84a41.47,41.47,0,0,0-7.47-6.8c-3.06-1.35-3,.91-3,.91L218.25,213s16.53,9.85,17.55,9.85,45.68,1.48,45.68,1.48,3,1.4,4.88,2.59,13.87,5,13.87,5,.8-.4-.1-1.1-6.68-3.49-6.68-3.49l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6S307.71,223.84,307.12,223.44Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M237.59,209.24c-4.31-5.31-12.92-15.91-15.26-18.75a41.47,41.47,0,0,0-7.47-6.8c-3.06-1.35-3,.91-3,.91L218.25,213s7.46,4.44,12.66,7.36Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M193.4,181.26s-8.68.4-14,6.29-4.69,18.85-2.49,26.63,5,12.07,4.39,14.77-2.79,3.59-1.6,6.08,8.08,5.19,20.25,4.79,14.47-3,14.57-5.28-.8-4.19-.5-5.59,9.08-9.18,9.08-17.76-3.79-11.57-4.69-17.76-.6-7.08-4.29-9.78S198.29,179.56,193.4,181.26Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M189.46,211a41.42,41.42,0,0,1-9.57,6", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M190.42,212s-2.15,6.94-7.42,10.77", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "211.96 187.54 212.96 197.12 208.76 192.23 211.96 187.54", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "206.37 197.92 211.96 187.54 206.87 182.06 206.37 197.92", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M195.6,164.3a42.56,42.56,0,0,1,1.29,10.58,39,39,0,0,1-.7,6.88l10.18,16.16,2.89-15,1.9-10.38S199.59,171.88,195.6,164.3Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "205.77 189.24 206.37 197.92 203.38 193.23 205.77 189.24", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "192.8 181.36 202.08 198.02 205.77 189.24 195.9 175.67 192.8 181.36", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 271.17, y: 189.13, width: 84.21, height: 69.1, style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-12--inject-33)"
} }, /* @__PURE__ */ React.createElement("rect", { x: 271.17, y: 189.13, width: 84.21, height: 69.1, style: {
  opacity: 0.2
} })), /* @__PURE__ */ React.createElement("rect", { x: 271.17, y: 189.13, width: 84.21, height: 69.1, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("rect", { x: 253.34, y: 189.13, width: 84.21, height: 69.1, style: {
  fill: "#4166FB",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z", style: {
  fill: "#4166FB"
} }), /* @__PURE__ */ React.createElement("g", { style: {
  clipPath: "url(#freepik--clip-path-13--inject-33)"
} }, /* @__PURE__ */ React.createElement("path", { d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z", style: {
  opacity: 0.2
} })), /* @__PURE__ */ React.createElement("path", { d: "M369.25,281.49c-2.7-4.28-13.87-23.26-13.87-23.26H337.56l9.17,23.26Z", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M239.42,281.49c2.7-4.28,13.86-23.26,13.86-23.26h17.83l-9.17,23.26Z", style: {
  fill: "#4166FB",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("polygon", { points: "253.28 258.23 245.53 281.49 333.48 281.49 337.56 258.23 253.28 258.23", style: {
  fill: "#4166FB",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 366.22, y1: 214.13, x2: 366.22, y2: 237.27, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 370.6, y1: 224.14, x2: 370.6, y2: 242.9, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 244.29, y1: 237.27, x2: 244.29, y2: 251.65, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("line", { x1: 240.54, y1: 245.4, x2: 240.54, y2: 256.65, style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M178.93,206.1a46.15,46.15,0,0,0,10.28,8.68c6,3.59,28,16.06,29.73,16.76s54.27-7.88,54.27-7.88,3,1.4,4.89,2.59,13.87,5,13.87,5,.8-.4-.1-1.09-6.68-3.5-6.68-3.5l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6s.9-1.1.3-1.5S286,219.57,286,219.57s13.07-1.1,13.17-1.6.5-1.09-.3-1.19-17.16-1.7-17.16-1.7,4.29-2.69,4.79-3.49,1.2-2.4.4-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.79,3.6-4.79,3.6l-48.08.1L195.5,193.93", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M298.85,216.78c-.79-.1-17.16-1.7-17.16-1.7s4.29-2.69,4.79-3.49,1.2-2.4.4-2.4-1,.5-2.09,1.2-5.39,2.4-6.59,3.39-4.79,3.6-4.79,3.6l-48.08.1L220,213.25c-2,3.51-5.74,10.09-8.17,14.43,3.74,2.08,6.57,3.63,7.14,3.86,1.7.7,54.27-7.88,54.27-7.88s3,1.4,4.89,2.59,13.87,5,13.87,5,.8-.4-.1-1.09-6.68-3.5-6.68-3.5l12,2.6s.7-.5.4-1-11-4.59-11-4.59l12,.6s.9-1.1.3-1.5S286,219.57,286,219.57s13.07-1.1,13.17-1.6S299.65,216.88,298.85,216.78Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M218.34,155.92a1.43,1.43,0,0,1,2.5.6,8.08,8.08,0,0,1-1.6,6.18c-1.1,1.1-2.1,1.4-2.1,0A63.83,63.83,0,0,1,218.34,155.92Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M206.06,138.44a20.41,20.41,0,0,1-5.87,12.91,48.85,48.85,0,0,1-10.76,8s.58,3.13,1.76,4.11,3.52.79,3.52.79a25.37,25.37,0,0,0,6.46,9.78c4.69,4.3,10.17,3.91,13.3-2.54s4.7-12.92,4.31-16.64l-.39-3.72S208.21,145.48,206.06,138.44Z", style: {
  fill: "#fff",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("ellipse", { cx: 205.47, cy: 156.18, rx: 0.9, ry: 1.6, style: {
  fill: "#263238"
} }), /* @__PURE__ */ React.createElement("ellipse", { cx: 210.36, cy: 168.95, rx: 0.9, ry: 1.6, style: {
  fill: "#263238"
} }), /* @__PURE__ */ React.createElement("ellipse", { cx: 214.15, cy: 156.18, rx: 0.9, ry: 1.6, style: {
  fill: "#263238"
} }), /* @__PURE__ */ React.createElement("path", { d: "M212.35,154.48a9.4,9.4,0,0,0-.3,3.69c.3,1.7,1.7,4.59.5,5.09a3.29,3.29,0,0,1-3.39-.4", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M202.87,153.29s.48-3.06,4.49-2.71", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "M213.61,151.52s3.74-3,4.95,2.49", style: {
  fill: "none",
  stroke: "#263238",
  strokeLinecap: "round",
  strokeLinejoin: "round"
} })));
export default SvgWomanEmptyBox;
